import type { KarlCustomPayload } from "@/components/document-chat/services/streamEventTypes";
import { KarlEventContent, KarlNodeRaw, StreamPhase } from "@/constants/enums";
// Types are globally available from @/types/chat-sse.d.ts
import type { DocumentChatRuntime } from "../types";

/**
 * Handles TOOL_CALL events for both answer_question and other tools
 *
 * @param payload - The tool call event payload
 * @param session - The current stream session
 * @param runtime - The document chat runtime store interface
 */
export function handleToolCallEvent(
  payload: KarlCustomPayload,
  session: StreamSession,
  runtime: DocumentChatRuntime
): void {
  const rawName = String(payload.title ?? "");
  const id = String((payload.id ?? rawName) || Date.now());
  const phaseStr = String(payload.content ?? "").toUpperCase(); // START | FINISHED

  if (rawName === KarlNodeRaw.AnswerQuestion) {
    if (phaseStr === KarlEventContent.START) {
      session.answerToolActive = true;
      session.answerJsonStream = "";
      session.answerHasStreamed = false;
      runtime.markAnswerStart();
      runtime.update({ phase: StreamPhase.ANSWERING });
    } else if (phaseStr === KarlEventContent.FINISHED) {
      session.answerToolActive = false;
    }
  } else {
    if (phaseStr === KarlEventContent.START) {
      runtime.addToolCall(id, rawName);
    } else if (phaseStr === KarlEventContent.FINISHED) {
      runtime.finishToolCall(id);
    }
  }
}
